import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../api/index';
import { Toast } from 'antd-mobile';
import { withRouter } from 'react-router-dom';
import styles from './index.module.scss';
import icon_alk_more from '../../static/images_ae/personal/icon_alk_more.png';

const api = new ApiCore();

const AlkPrivacy = (props: any) => {


    useEffect(() => {
        window.document.title = '用户协议&隐私政策';
    }, [])


    const toUser = () => {
        // props.history.push('/alk/privacy/user');
        props.history.push('/alk/privacy/index?tab=user');
    }

    const toPrivacy = () => {
        props.history.push('/alk/privacy/index?tab=aggrement');
    }

    return (
        <div className={styles.alk_privacy_content}>
            <div className={styles.item} onClick={toUser}>
                <div>用户服务协议</div>
                <img className={styles.icon_more} src={icon_alk_more} alt="" />
            </div>
            <div className={styles.item}  onClick={toPrivacy}>
                <div>隐私政策</div>
                <img className={styles.icon_more} src={icon_alk_more} alt="" />
            </div>
        </div>
    )
}

export default withRouter(AlkPrivacy);